module.exports = __webpack_public_path__ + "fonts/HelveticaNeueCyrThin.7b26442.woff2";